export const APP_URL = {
  API_BASE_URL: process.env["NEXT_PUBLIC_API_BASE_URL"],
  PROXY_API_BASE_URL: process.env["NEXT_PUBLIC_PROXY_API_BASE_URL"],
  NEXT_PUBLIC_APP_BASE_URL: process.env["NEXT_PUBLIC_APP_BASE_URL"],
  NEXT_PUBLIC_RUDDERSTACK_SOURCE_WRITE_KEY: process.env["NEXT_PUBLIC_RUDDERSTACK_SOURCE_WRITE_KEY"],
  S3_CDN: process.env["NEXT_PUBLIC_S3_CDN"],
};

/** Canonical site origin for robots.txt, sitemap, and absolute links (no trailing slash). */
export function getPublicSiteUrl(): string {
  const explicit = process.env["NEXT_PUBLIC_APP_BASE_URL"]?.trim();
  if (explicit) return explicit.replace(/\/+$/, "");
  const vercel = process.env["VERCEL_URL"]?.trim();
  if (vercel) return `https://${vercel.replace(/^https?:\/\//, "")}`;
  return "http://localhost:3000";
}
